module.exports = __webpack_public_path__ + "d42dcceedc1ac8af3c965aeffd74ad0b.MP3";